
import { defineComponent, PropType } from "vue";
import StatCard from "@/components/dashboard/sequence/StatCard.vue";

interface DashboardData {
  overAllAvailableBalance?: number | string;
  travelgc?: number | string;
  productgc?: number | string;
  currency?: string;
}

export default defineComponent({
  name: "OVISequenceOverview",
  components: {
    StatCard,
  },
  props: {
    dashboardData: {
      type: Object as PropType<DashboardData>,
      default: () => ({}),
    },
  },
});
